import { IconProfile24 } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../../../selectors/page';
import { IMobileNavigationItem } from '../../../types/mobileBottomNavigation';
import { IApplicationState } from '../../../types/redux';
import { trackNavigationItemClick } from '../tracking';

export const useProfileNavigationItem = (): IMobileNavigationItem => {
  const userProfileLink = useSelector<IApplicationState, string>(
    state => state.userArea.userCabinetUrl || /* istanbul ignore next */ 'https://my.cian.ru/',
  );

  const page = useSelector(selectPageType);

  const handleClick = useCallback(() => {
    trackNavigationItemClick('profile');
  }, []);

  return {
    title: 'Профиль',
    link: userProfileLink,
    icon: IconProfile24,
    isActive: page === 'lk',
    onClick: handleClick,
  };
};
